import { render, staticRenderFns } from "./TextTable.vue?vue&type=template&id=1bd3f663&scoped=true&"
import script from "./TextTable.vue?vue&type=script&lang=js&"
export * from "./TextTable.vue?vue&type=script&lang=js&"
import style0 from "./TextTable.vue?vue&type=style&index=0&id=1bd3f663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3f663",
  null
  
)

export default component.exports